var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackSubmissionLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 133,
    viewBox: "0 0 220 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.881 11.7207C150.037 -6.36244 123.197 -1.39904 108.451 12.2732C97.6754 22.2783 80.7016 36.7857 67.5601 36.1549C54.5317 35.5242 39.6371 26.4891 23.4506 33.4492C7.47717 40.3049 3.11407 62.9817 10.3352 80.321C17.5823 97.7212 44.0263 111.863 76.0209 125.053C87.7747 129.976 100.411 132.445 113.153 132.308C113.153 132.308 142.116 132.008 152.999 125.044C161.521 119.58 165.171 115.991 174.384 102.084C181.344 91.5572 186.008 76.7583 186.53 62.4205C187.186 44.9029 182.958 25.232 168.881 11.7207Z",
    fill: "#99C5EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M168.881 11.7207C150.037 -6.36244 123.197 -1.39904 108.451 12.2732C97.6754 22.2783 80.7016 36.7857 67.5601 36.1549C54.5317 35.5242 39.6371 26.4891 23.4506 33.4492C7.47717 40.3049 3.11407 62.9817 10.3352 80.321C17.5823 97.7212 44.0263 111.863 76.0209 125.053C87.7747 129.976 100.411 132.445 113.153 132.308C113.153 132.308 142.116 132.008 152.999 125.044C161.521 119.58 165.171 115.991 174.384 102.084C181.344 91.5572 186.008 76.7583 186.53 62.4205C187.186 44.9029 182.958 25.232 168.881 11.7207Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.042 53.5059H80.3326C78.4899 53.5059 76.9961 54.9996 76.9961 56.8423V113.228C76.9961 115.07 78.4899 116.564 80.3326 116.564H107.042C108.885 116.564 110.378 115.07 110.378 113.228V56.8423C110.378 54.9996 108.885 53.5059 107.042 53.5059Z",
    fill: "#454F5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.895 60.4307H78.4795V109.643H108.895V60.4307Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_130_4335",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 60,
    width: 31,
    height: 50
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.895 60.4307H78.4795V109.643H108.895V60.4307Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_130_4335)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.895 93.1035L80.5415 109.638H108.895V93.1035Z",
    fill: "#99C5EF"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.895 60.4307H78.4795V109.643H108.895V60.4307Z",
    stroke: "#454F5B",
    strokeWidth: 0.52825,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9934 56.9862H90.3813C90.2659 56.9862 90.1553 56.9404 90.0737 56.8588C89.9921 56.7772 89.9463 56.6666 89.9463 56.5512C89.9463 56.4358 89.9921 56.3252 90.0737 56.2436C90.1553 56.162 90.2659 56.1162 90.3813 56.1162H96.9934C97.1087 56.1162 97.2194 56.162 97.301 56.2436C97.3825 56.3252 97.4284 56.4358 97.4284 56.5512C97.4284 56.6666 97.3825 56.7772 97.301 56.8588C97.2194 56.9404 97.1087 56.9862 96.9934 56.9862Z",
    fill: "#99C5EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M96.9934 56.9862H90.3813C90.2659 56.9862 90.1553 56.9404 90.0737 56.8588C89.9921 56.7772 89.9463 56.6666 89.9463 56.5512C89.9463 56.4358 89.9921 56.3252 90.0737 56.2436C90.1553 56.162 90.2659 56.1162 90.3813 56.1162H96.9934C97.1087 56.1162 97.2194 56.162 97.301 56.2436C97.3825 56.3252 97.4284 56.4358 97.4284 56.5512C97.4284 56.6666 97.3825 56.7772 97.301 56.8588C97.2194 56.9404 97.1087 56.9862 96.9934 56.9862Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4924 112.419C95.4924 112.062 95.3865 111.712 95.1881 111.416C94.9898 111.119 94.7078 110.887 94.378 110.751C94.0481 110.614 93.6851 110.578 93.3349 110.648C92.9847 110.718 92.6631 110.89 92.4106 111.142C92.1581 111.395 91.9862 111.716 91.9165 112.066C91.8469 112.417 91.8826 112.78 92.0193 113.109C92.1559 113.439 92.3873 113.721 92.6842 113.92C92.981 114.118 93.3301 114.224 93.6871 114.224C94.1659 114.224 94.6251 114.034 94.9636 113.695C95.3022 113.357 95.4924 112.897 95.4924 112.419Z",
    fill: "#99C5EF",
    stroke: "#454F5B",
    strokeWidth: 0.704333,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6009 111.505H92.7739V113.332H94.6009V111.505Z",
    fill: "#99C5EF",
    stroke: "#454F5B",
    strokeWidth: 0.52825,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M94.6009 111.505H92.7739V113.332H94.6009V111.505Z",
    fill: "white",
    stroke: "#454F5B",
    strokeWidth: 0.52825,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6009 111.505H92.7739V113.332H94.6009V111.505Z",
    stroke: "#454F5B",
    strokeWidth: 0.52825,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M197.41 111.856V72.9366C197.41 70.2506 195.232 68.0732 192.546 68.0732H110.387C107.701 68.0732 105.524 70.2506 105.524 72.9366V111.856C105.524 114.542 107.701 116.72 110.387 116.72H192.546C195.232 116.72 197.41 114.542 197.41 111.856Z",
    fill: "#99C5EF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.921 70.7354H192.011V114.058H110.921V70.7354Z",
    fill: "white",
    stroke: "#006FD6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_130_4335",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 70,
    width: 83,
    height: 45
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.921 70.7354H192.011V114.058H110.921V70.7354Z",
    fill: "white",
    stroke: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_130_4335)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M192.011 114.053H133.621L192.011 80.0013V114.053Z",
    fill: "#99C5EF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M192.011 114.053H133.621L192.011 80.0013V114.053Z",
    stroke: "#084E96"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M192.511 114.558V70.2354H110.421V114.558H192.511Z",
    stroke: "#006FD6",
    strokeWidth: 0.651505,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M194.721 92.5605C194.688 92.5605 194.655 92.5505 194.627 92.5318L194.358 92.9337L194.627 92.5318C194.599 92.5131 194.577 92.4865 194.564 92.4554C194.551 92.4243 194.548 92.39 194.555 92.357C194.561 92.3241 194.578 92.2938 194.601 92.2701C194.625 92.2464 194.656 92.2303 194.689 92.2238C194.722 92.2174 194.756 92.2209 194.787 92.234C194.818 92.247 194.844 92.2689 194.863 92.297C194.882 92.3251 194.891 92.3581 194.891 92.3917C194.891 92.4366 194.873 92.4795 194.841 92.5111C194.809 92.5428 194.766 92.5605 194.721 92.5605Z",
    fill: "#006FD6",
    stroke: "#006FD6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M182.828 68.5176H185.764C185.853 68.5176 185.925 68.4455 185.925 68.3566V68.2348C185.925 68.1459 185.853 68.0739 185.764 68.0739H182.828C182.739 68.0739 182.667 68.1459 182.667 68.2348V68.3566C182.667 68.4455 182.739 68.5176 182.828 68.5176Z",
    fill: "#99C5EF",
    stroke: "#006FD6",
    strokeWidth: 0.652671,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M172.458 68.5131H178.082C178.112 68.5137 178.141 68.5084 178.169 68.4975C178.196 68.4866 178.221 68.4703 178.242 68.4497C178.263 68.429 178.28 68.4044 178.291 68.3772C178.303 68.3499 178.309 68.3207 178.309 68.2912C178.309 68.2617 178.303 68.2325 178.291 68.2053C178.28 68.1781 178.263 68.1535 178.242 68.1328C178.221 68.1121 178.196 68.0959 178.169 68.085C178.141 68.0741 178.112 68.0688 178.082 68.0694H172.458C172.399 68.0694 172.342 68.0928 172.301 68.1344C172.259 68.176 172.236 68.2324 172.236 68.2912C172.236 68.3501 172.259 68.4065 172.301 68.4481C172.342 68.4897 172.399 68.5131 172.458 68.5131Z",
    fill: "#99C5EF",
    stroke: "#006FD6",
    strokeWidth: 0.652671,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6924 119.314C87.6924 119.962 83.8121 120.488 79.0271 120.488C74.242 120.488 70.3574 119.966 70.3574 119.314C70.3574 118.661 74.2377 118.135 79.0271 118.135C83.8165 118.135 87.6924 118.661 87.6924 119.314Z",
    fill: "#90CAF9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5669 101.878C71.5669 111.779 79.397 119.8 79.397 119.8C79.397 119.8 87.2271 111.779 87.2271 101.878C87.2271 91.9775 79.397 83.9561 79.397 83.9561C79.397 83.9561 71.5669 91.9775 71.5669 101.878Z",
    fill: "#454F5B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4097 119.8V83.9561",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4102 96.6976L75.0166 92.8652",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4795 102.622L84.9127 94.7441",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4098 106.038L72.9282 100.252",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4795 110.635L85.8915 104.919",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4794 114.606L74.4595 110.635",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1335 114.746C69.9442 119.043 76.4301 119.505 76.4301 119.505C76.4301 119.505 76.7476 113.01 72.95 108.712C69.1525 104.414 62.6535 103.953 62.6535 103.953C62.6535 103.953 62.3098 110.469 66.1335 114.746Z",
    fill: "#454F5B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4303 119.522L62.6406 103.971",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5431 109.5L64.1631 109.526",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M69.853 112.044L69.1787 106.537",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1365 113.55L66.0991 113.537",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M72.937 115.52L73.5199 110.574",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4641 117.243L70.7578 117.452",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1175 108.582C82.1155 112.697 82.1372 119.205 82.1372 119.205C82.1372 119.205 88.6405 119.035 92.6382 114.915C96.6359 110.796 96.6185 104.306 96.6185 104.306C96.6185 104.306 90.1152 104.462 86.1175 108.582Z",
    fill: "#454F5B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1372 119.205L96.6185 104.293",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4727 109.592L91.1943 106.225",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M89.106 112.084L94.5479 111.005",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6965 113.475L87.3398 108.451",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8696 115.42L90.8461 115.629",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2646 117.073L83.7817 113.393",
    stroke: "white",
    strokeWidth: 0.738,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9966 20.4453C67.2057 20.4453 68.9966 22.2362 68.9966 24.4453V57.8734C68.9966 59.4334 67.7319 60.6981 66.1719 60.6981C64.6118 60.6981 63.3472 61.9728 63.3472 63.5328C63.3472 66.0797 60.2684 67.3801 58.4668 65.5799L54.7529 61.8686C54.0028 61.1191 52.9859 60.6981 51.9255 60.6981H3.99984C1.7907 60.6981 -0.000160217 58.9072 -0.000160217 56.6981V24.4453C-0.000160217 22.2362 1.7907 20.4453 3.99984 20.4453H64.9966Z",
    fill: "#99C5EF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4565 40.572C21.4565 41.2185 21.2648 41.8506 20.9056 42.3882C20.5463 42.9259 20.0358 43.3449 19.4384 43.5923C18.841 43.8398 18.1837 43.9045 17.5495 43.7784C16.9153 43.6522 16.3328 43.3409 15.8756 42.8836C15.4184 42.4264 15.1071 41.8439 14.9809 41.2098C14.8548 40.5756 14.9195 39.9183 15.1669 39.3209C15.4144 38.7235 15.8334 38.2129 16.371 37.8537C16.9086 37.4945 17.5407 37.3027 18.1873 37.3027C18.6166 37.3027 19.0418 37.3873 19.4384 37.5516C19.835 37.7159 20.1954 37.9567 20.499 38.2603C20.8026 38.5638 21.0434 38.9242 21.2077 39.3209C21.372 39.7175 21.4565 40.1426 21.4565 40.572Z",
    fill: "#E7F1FB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7676 40.572C37.7676 41.2185 37.5758 41.8506 37.2166 42.3882C36.8574 42.9259 36.3468 43.3449 35.7494 43.5923C35.1521 43.8398 34.4947 43.9045 33.8606 43.7784C33.2264 43.6522 32.6439 43.3409 32.1867 42.8836C31.7294 42.4264 31.4181 41.8439 31.2919 41.2098C31.1658 40.5756 31.2305 39.9183 31.478 39.3209C31.7254 38.7235 32.1445 38.2129 32.6821 37.8537C33.2197 37.4945 33.8518 37.3027 34.4984 37.3027C35.3654 37.3027 36.197 37.6472 36.8101 38.2603C37.4232 38.8734 37.7676 39.7049 37.7676 40.572Z",
    fill: "#E7F1FB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0786 40.572C54.0786 41.2189 53.8867 41.8512 53.5272 42.389C53.1676 42.9267 52.6566 43.3458 52.0589 43.593C51.4611 43.8402 50.8034 43.9046 50.169 43.7778C49.5347 43.6511 48.9522 43.3391 48.4952 42.8812C48.0383 42.4233 47.7275 41.8401 47.6021 41.2055C47.4768 40.5708 47.5425 39.9133 47.791 39.316C48.0396 38.7188 48.4597 38.2087 48.9982 37.8503C49.5368 37.4919 50.1695 37.3014 50.8164 37.3027C51.6822 37.3046 52.512 37.6498 53.1236 38.2627C53.7352 38.8756 54.0786 39.7061 54.0786 40.572Z",
    fill: "#E7F1FB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M170.607 4.78516C168.398 4.78516 166.607 6.57602 166.607 8.78516V33.7488C166.607 34.9561 167.586 35.9347 168.793 35.9347C170 35.9347 170.979 36.9211 170.979 38.1284C170.979 40.0992 173.361 41.1056 174.755 39.7125L177.429 37.0406C178.138 36.3325 179.099 35.9347 180.1 35.9347H216C218.209 35.9347 220 34.1439 220 31.9347V8.78516C220 6.57602 218.209 4.78516 216 4.78516H170.607Z",
    fill: "#99C5EF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M203.396 20.36C203.396 20.8603 203.544 21.3495 203.822 21.7655C204.1 22.1815 204.495 22.5058 204.958 22.6973C205.42 22.8888 205.929 22.9389 206.419 22.8412C206.91 22.7436 207.361 22.5027 207.715 22.1489C208.069 21.7951 208.31 21.3443 208.407 20.8535C208.505 20.3628 208.455 19.8541 208.263 19.3918C208.072 18.9295 207.747 18.5344 207.331 18.2564C206.915 17.9785 206.426 17.8301 205.926 17.8301C205.594 17.8301 205.265 17.8955 204.958 18.0227C204.651 18.1498 204.372 18.3361 204.137 18.5711C203.902 18.806 203.716 19.0849 203.589 19.3918C203.461 19.6988 203.396 20.0277 203.396 20.36Z",
    fill: "#E7F1FB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M190.774 20.36C190.774 20.8603 190.922 21.3495 191.2 21.7655C191.478 22.1815 191.873 22.5058 192.336 22.6973C192.798 22.8888 193.307 22.9389 193.797 22.8412C194.288 22.7436 194.739 22.5027 195.093 22.1489C195.447 21.7951 195.687 21.3443 195.785 20.8535C195.883 20.3628 195.833 19.8541 195.641 19.3918C195.45 18.9295 195.125 18.5344 194.709 18.2564C194.293 17.9785 193.804 17.8301 193.304 17.8301C192.633 17.8301 191.989 18.0966 191.515 18.5711C191.04 19.0455 190.774 19.689 190.774 20.36Z",
    fill: "#E7F1FB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M178.151 20.36C178.151 20.8606 178.3 21.3499 178.578 21.7661C178.856 22.1822 179.252 22.5065 179.714 22.6978C180.177 22.8891 180.686 22.9389 181.177 22.8408C181.668 22.7428 182.118 22.5013 182.472 22.1469C182.826 21.7926 183.066 21.3413 183.163 20.8502C183.26 20.3591 183.209 19.8502 183.017 19.3881C182.825 18.9259 182.5 18.5311 182.083 18.2538C181.666 17.9765 181.176 17.829 180.676 17.8301C180.006 17.8315 179.364 18.0987 178.89 18.573C178.417 19.0473 178.151 19.6899 178.151 20.36Z",
    fill: "#E7F1FB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.828 124.062C174.936 123.514 174.191 122.724 173.023 122.836C172.577 122.885 172.671 122.51 172.666 122.27L172.613 109.088C172.613 108.771 172.613 108.508 172.978 108.329C176.327 106.626 177.772 103.29 179.819 100.441C180.869 99.0243 181.622 97.411 182.034 95.6971C182.446 93.9831 182.509 92.2037 182.218 90.4651C182.076 89.4751 182.535 89.0336 183.427 88.8285C184.497 88.5787 185.567 88.8731 185.937 89.6089C186.907 91.3999 187.562 93.3442 187.873 95.357C188.069 97.0248 187.48 98.6481 187.275 100.298C187.128 101.502 186.829 102.697 186.624 103.919C186.919 104.133 187.262 104.022 187.579 104.022C191.289 104.022 195.005 104.011 198.727 103.99C200.288 103.99 201.059 104.436 201.278 105.471C201.4 106.109 201.309 106.77 201.019 107.352C200.729 107.934 200.256 108.404 199.672 108.691C199.396 108.833 198.892 108.691 198.861 109.137C198.83 109.583 199.347 109.533 199.601 109.712C200.939 110.63 200.707 112.53 199.155 113.636C198.781 113.899 198.058 113.779 198.04 114.327C198.04 114.773 198.714 114.773 199.021 115.063C200.109 116.133 199.574 118.136 197.956 118.952C197.733 119.02 197.516 119.104 197.304 119.201C197.122 119.326 196.943 119.469 197.304 119.719C198.914 120.86 198.888 122.461 197.273 123.634L196.792 123.982C196.207 124.34 195.521 124.496 194.838 124.428C189.02 124.461 183.199 124.481 177.375 124.49C177.102 124.526 176.824 124.506 176.559 124.432C176.293 124.359 176.044 124.233 175.828 124.062Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.252 116.365C159.252 113.578 159.252 110.782 159.212 107.995C159.212 107.424 159.265 107.148 159.961 107.152C163.368 107.184 166.766 107.152 170.173 107.121C170.842 107.121 170.945 107.344 170.945 107.937C170.945 113.553 170.964 119.169 171.003 124.785C171.003 125.503 170.815 125.703 170.111 125.677C166.806 125.65 163.506 125.654 160.206 125.717C159.386 125.717 159.27 125.445 159.274 124.727C159.297 121.953 159.261 119.161 159.252 116.365Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M169.714 108.472L170.847 110.108L172.746 110.679L171.542 112.258L171.592 114.247L169.714 113.591L167.837 114.247L167.881 112.258L166.677 110.679L168.581 110.108L169.714 108.472Z",
    fill: "#084E96"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M124.52 44.8164L126.794 48.2064L130.724 49.3226L128.201 52.5308L128.351 56.6113L124.52 55.2044L120.689 56.6113L120.839 52.5308L118.321 49.3226L122.246 48.2064L124.52 44.8164Z",
    fill: "#084E96"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M142.062 44.8164L144.335 48.2064L148.26 49.3226L145.742 52.5308L145.893 56.6113L142.062 55.2044L138.225 56.6113L138.381 52.5308L135.858 49.3226L139.788 48.2064L142.062 44.8164Z",
    fill: "#084E96"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M159.598 44.8164L161.877 48.2064L165.802 49.3226L163.279 52.5308L163.435 56.6113L159.598 55.2044L155.767 56.6113L155.918 52.5308L153.4 49.3226L157.325 48.2064L159.598 44.8164Z",
    fill: "#084E96"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M177.14 44.8164L179.414 48.2064L183.344 49.3226L180.821 52.5308L180.972 56.6113L177.14 55.2044L173.309 56.6113L173.46 52.5308L170.937 49.3226L174.866 48.2064L177.14 44.8164Z",
    fill: "#084E96"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M198.788 56.9853L194.682 55.4797L190.575 56.9853L190.736 52.6141L188.037 49.1981L192.242 48.0041L194.682 44.3701L197.116 48.0041L201.327 49.1981L198.627 52.64L198.788 56.9853ZM194.682 54.9087L198.238 56.2117L198.098 52.4272L200.439 49.4421L196.805 48.4038L194.692 45.2527L192.579 48.4038L188.945 49.4421L191.286 52.4272L191.146 56.2117L194.682 54.9087Z",
    fill: "#084E96"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M194.682 55.2044V44.8164L192.408 48.2064L188.478 49.3226L191.001 52.5308L190.845 56.6113L194.682 55.2044Z",
    fill: "#084E96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackSubmissionLogo);
export default __webpack_public_path__ + "static/media/feedback_submission_logo.5e119218e25f7e50a8c7e2bfbc50aaa8.svg";
export { ForwardRef as ReactComponent };